// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ——— New package page (Stitch: New package — create form) ——— */
.pkg-form-page {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  min-height: 100%;
  padding: 0 0 48px;
  background: #ffffff;
  overflow-x: hidden;
}

.pkg-form-page__header {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  padding: 24px 32px 0;
  background: #ffffff;
}

.pkg-form-page__breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding-bottom: 16px;
  margin-bottom: 24px;
  border-bottom: 1px solid #F1F5F9;
  font-size: 12px;
  font-weight: 500;
  color: #64748B;
  line-height: 1.3;
}

.pkg-form-page__sep {
  color: #CBD5E1;
}

.pkg-form-page__crumb {
  color: #64748B;
  text-decoration: none;
  transition: color 0.12s ease;
}

.pkg-form-page__crumb:hover {
  color: #0F172A;
}

.pkg-form-page__crumb--muted {
  pointer-events: none;
}

.pkg-form-page__crumb--current {
  color: #0EA5E9;
  font-weight: 600;
}

.pkg-form-page__title-row {
  display: flex;
  align-items: flex-start;
  gap: 14px;
  min-width: 0;
  padding-bottom: 8px;
}

.pkg-form-page__back {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  margin-top: 2px;
  border: 1px solid #E2E8F0;
  border-radius: 12px;
  background: #ffffff;
  color: #475569;
  cursor: pointer;
  flex-shrink: 0;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
}

.pkg-form-page__back:hover {
  background: #F8FAFC;
  color: #0F172A;
}

[dir='rtl'] .pkg-form-page__back .lucide {
  transform: scaleX(-1);
}

.pkg-form-page__title {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  color: #0F172A;
  letter-spacing: -0.02em;
  line-height: 1.25;
}

.pkg-form-page__canvas {
  box-sizing: border-box;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  margin: 0;
  padding: 16px 32px 8px;
}

.pkg-form-page__hint {
  margin: 0;
  font-size: 12px;
  color: #94A3B8;
  line-height: 1.45;
}

.pkg-form-page__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #E2E8F0;
}

.pkg-form-page__footer-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  margin-inline-start: auto;
}

.pkg-form-page__btn {
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 40px;
  padding: 0 20px;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 500;
  font-family: inherit;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

.pkg-form-page__btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.pkg-form-page__btn--ghost {
  border: 1px solid #E2E8F0;
  background: #ffffff;
  color: #475569;
}

.pkg-form-page__btn--ghost:hover:not(:disabled) {
  background: #F8FAFC;
  color: #0F172A;
}

.pkg-form-page__btn--primary {
  padding-inline: 24px;
  border: 1px solid #0EA5E9;
  background: #0EA5E9;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);
}

.pkg-form-page__btn--primary:hover:not(:disabled) {
  background: #0284C7;
  border-color: #0284C7;
}

@media (max-width: 720px) {
  .pkg-form-page__header,
  .pkg-form-page__canvas {
    padding-left: 16px;
    padding-right: 16px;
  }

  .pkg-form-page__title {
    font-size: 20px;
  }

  .pkg-form-page__footer {
    flex-direction: column;
    align-items: stretch;
  }

  .pkg-form-page__footer-actions {
    width: 100%;
    margin-inline-start: 0;
  }

  .pkg-form-page__footer-actions .pkg-form-page__btn {
    flex: 1 1 auto;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/NewPackage/style.css"],"names":[],"mappings":"AAAA,iEAAiE;AACjE;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,SAAS;EACT,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;;IAEE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,cAAc;EAChB;AACF","sourcesContent":["/* ——— New package page (Stitch: New package — create form) ——— */\n.pkg-form-page {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  padding: 0 0 48px;\n  background: #ffffff;\n  overflow-x: hidden;\n}\n\n.pkg-form-page__header {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  padding: 24px 32px 0;\n  background: #ffffff;\n}\n\n.pkg-form-page__breadcrumb {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding-bottom: 16px;\n  margin-bottom: 24px;\n  border-bottom: 1px solid #F1F5F9;\n  font-size: 12px;\n  font-weight: 500;\n  color: #64748B;\n  line-height: 1.3;\n}\n\n.pkg-form-page__sep {\n  color: #CBD5E1;\n}\n\n.pkg-form-page__crumb {\n  color: #64748B;\n  text-decoration: none;\n  transition: color 0.12s ease;\n}\n\n.pkg-form-page__crumb:hover {\n  color: #0F172A;\n}\n\n.pkg-form-page__crumb--muted {\n  pointer-events: none;\n}\n\n.pkg-form-page__crumb--current {\n  color: #0EA5E9;\n  font-weight: 600;\n}\n\n.pkg-form-page__title-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 14px;\n  min-width: 0;\n  padding-bottom: 8px;\n}\n\n.pkg-form-page__back {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  margin-top: 2px;\n  border: 1px solid #E2E8F0;\n  border-radius: 12px;\n  background: #ffffff;\n  color: #475569;\n  cursor: pointer;\n  flex-shrink: 0;\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n}\n\n.pkg-form-page__back:hover {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n[dir='rtl'] .pkg-form-page__back .lucide {\n  transform: scaleX(-1);\n}\n\n.pkg-form-page__title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  color: #0F172A;\n  letter-spacing: -0.02em;\n  line-height: 1.25;\n}\n\n.pkg-form-page__canvas {\n  box-sizing: border-box;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  margin: 0;\n  padding: 16px 32px 8px;\n}\n\n.pkg-form-page__hint {\n  margin: 0;\n  font-size: 12px;\n  color: #94A3B8;\n  line-height: 1.45;\n}\n\n.pkg-form-page__footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 32px;\n  padding-top: 24px;\n  border-top: 1px solid #E2E8F0;\n}\n\n.pkg-form-page__footer-actions {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  margin-inline-start: auto;\n}\n\n.pkg-form-page__btn {\n  box-sizing: border-box;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 20px;\n  border-radius: 12px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: inherit;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\n.pkg-form-page__btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.pkg-form-page__btn--ghost {\n  border: 1px solid #E2E8F0;\n  background: #ffffff;\n  color: #475569;\n}\n\n.pkg-form-page__btn--ghost:hover:not(:disabled) {\n  background: #F8FAFC;\n  color: #0F172A;\n}\n\n.pkg-form-page__btn--primary {\n  padding-inline: 24px;\n  border: 1px solid #0EA5E9;\n  background: #0EA5E9;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 1px 2px rgba(14, 165, 233, 0.2);\n}\n\n.pkg-form-page__btn--primary:hover:not(:disabled) {\n  background: #0284C7;\n  border-color: #0284C7;\n}\n\n@media (max-width: 720px) {\n  .pkg-form-page__header,\n  .pkg-form-page__canvas {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  .pkg-form-page__title {\n    font-size: 20px;\n  }\n\n  .pkg-form-page__footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .pkg-form-page__footer-actions {\n    width: 100%;\n    margin-inline-start: 0;\n  }\n\n  .pkg-form-page__footer-actions .pkg-form-page__btn {\n    flex: 1 1 auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
